import { render, staticRenderFns } from "./ClusterPermissionsEditor.vue?vue&type=template&id=908b2534&scoped=true&"
import script from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js&"
export * from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClusterPermissionsEditor.vue?vue&type=style&index=0&id=908b2534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908b2534",
  null
  
)

export default component.exports